import { render } from "./VueCard.vue?vue&type=template&id=ce9a8a88&scoped=true"
import script from "./VueCard.vue?vue&type=script&lang=js"
export * from "./VueCard.vue?vue&type=script&lang=js"

import "./VueCard.vue?vue&type=style&index=0&id=ce9a8a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9a8a88"]])

export default __exports__